const ASSESSMENT_KINDS = new Set([
  "MultipleChoice",
  "TrueFalse",
  "MultipleAnswer",
  "FillInBlank",
  "DragDrop",
  "Matching",
  "Ordering",
]);

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "t_" + Math.random().toString(36).slice(2);
}

export function generateBaselineWorkflow(section, navItemsById, boxesById, pluginToolbarsById) {
  const triggers = [];
  const variables = [];
  const sceneIds = section.children || [];

  sceneIds.forEach((sceneId, idx) => {
    const scene = navItemsById[sceneId];
    if (!scene) return;
    const next = sceneIds[idx + 1];

    const sceneBoxes = (scene.boxes || []).map((bId) => ({
      boxId: bId,
      toolbar: pluginToolbarsById[bId] || {},
    }));

    let consumedByAssessment = false;
    let consumedByHotspot = false;

    for (const { boxId, toolbar } of sceneBoxes) {
      if (ASSESSMENT_KINDS.has(toolbar.pluginId)) {
        consumedByAssessment = true;
        triggers.push({
          id: uuid(),
          sceneId,
          pluginBoxId: boxId,
          on: "onAnswer.correct",
          actions: next
            ? [{ kind: "resume" }, { kind: "jumpScene", target: next }]
            : [{ kind: "resume" }],
        });
        triggers.push({
          id: uuid(),
          sceneId,
          pluginBoxId: boxId,
          on: "onAnswer.wrong",
          actions: [{ kind: "replayItem", pluginBoxId: boxId }],
        });
      }
      if (toolbar.pluginId === "HotspotImages") {
        const marks = (toolbar.state && toolbar.state.marks) || [];
        const usable = marks.filter(
          (m) => m && m.connection && (m.connectMode === "existing" || m.connectMode === "new")
        );
        if (usable.length > 0) {
          consumedByHotspot = true;
          for (const m of usable) {
            triggers.push({
              id: uuid(),
              sceneId,
              pluginBoxId: boxId,
              on: "onMarkClick",
              actions: [{ kind: "jumpScene", target: m.connection }],
            });
          }
        }
      }
    }

    if (!consumedByAssessment && !consumedByHotspot) {
      triggers.push({
        id: uuid(),
        sceneId,
        pluginBoxId: (scene.boxes && scene.boxes[0]) || "*",
        on: "onShow",
        actions: next
          ? [{ kind: "resume" }, { kind: "jumpScene", target: next }]
          : [{ kind: "resume" }],
      });
    }
  });

  return { variables, triggers };
}
